
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(k|lb|o|z3)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
